import { render } from "./Landing-Page.vue?vue&type=template&id=713067e7&scoped=true"
import script from "./Landing-Page.vue?vue&type=script&lang=js"
export * from "./Landing-Page.vue?vue&type=script&lang=js"

import "./Landing-Page.vue?vue&type=style&index=0&id=713067e7&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-713067e7"]])

export default __exports__